<div class="widget-search">
  <div class="input-group clearable-input" data-hj-ignore-attributes>
    <!-- focusable="false" is used to disable tabbing in IE for SVG -->
    <svg class="icon icon--xs icon-location" viewBox="0 0 32 32" focusable="false" *ngIf="!hotelPage">
      <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/Static/img/icons/sprites.svg#icon-map-marker"></use>
    </svg>
    <!-- (click)="showHistory()" for history feature in future -->
    <input autocomplete="off" spellcheck="false" data-hj-ignore-attributes type="text"
      [placeholder]="!hotelPage?search.placeholder:''"
      [ngClass]="hotelPage ? 'hero-search-section__search-input' : 'widget-search__text'" #widgetSearch
      id="widget-search__text" required="required" (click)="showHistory()" (keydown)="actOnKeyDown($event)"
      (keyup)="showSearchResults($event)" [(ngModel)]="search.value" (blur)="hideErrorMessage()" (focus)="showSearchResultsHotelPage($event)"/>
    <span class="clearable-input__clear" (click)="clearSearch()" *ngIf="search.value && !hotelPage">
      <svg class=" icon clearable-input__clear--icon icon--xdark-gray-stroke" stroke-width="5" viewBox="0 0 32 32">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/Static/img/icons/clear-input.svg#web-close"></use>
      </svg>
    </span>
    <label for="widget-search__text" *ngIf="!hotelPage">
      <span [innerHTML]="search.label"></span>
      <span class="hide-on-load">@ViewBag.BookingWidgetLabels.BookingWidgetSearchLabel</span>
    </label>
    <input type="hidden" name="city" *ngIf="search.stayType == 'CityPage'" [value]="search.stayValue"/>
    <input type="hidden" name="hotel" *ngIf="search.stayType != 'CityPage'" [value]="search.stayValue"/>
    <div [ngClass]="hotelPage ? 'error-widget-search' : 'error-text error-text--inverted'" *ngIf="isEmpty || noMatch">
      <div [ngClass]="{'error-widget-search-padding': (hotelPage && noMatch)}">
        <span *ngIf="isEmpty" [innerHTML]="search.reqdMsg"></span>
        <span *ngIf="noMatch" [innerHTML]="search.notFoundMsg"></span>
      </div>
    </div>
  </div>
  <div class="widget-search__list" [ngClass]="{'widget-search__list_98': hotelPage}"
    *ngIf="listItems && listItems.length > 0">
    <ul>
      <li *ngFor="let item of listItems; let i = index;" class="widget-search__list-item" [ngClass]="selectedIndex == i ? 'selected' : ''" (click)="selectItem(item, i)">
        <svg style="width: 18px;" class="icon icon--xs" [ngClass]="item.Type == 'CityPage' ? 'icon--dawn' : (item.Type == 'CountryPage' ? 'icon--nordicsea' : 'icon--crocus')" viewBox="0 0 32 32" focusable="false">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/Static/img/icons/sprites.svg#icon-map-marker"></use>
        </svg>
        <!-- the expression evalvuates to highlighting of the text part which is typed by user in search input -->
        <span [innerHTML]="item.Name.toLowerCase().replace(search.value.toLowerCase(), '<strong>'+search.value.toLowerCase()+'</strong>')"></span>
      </li>
    </ul>
  </div>
  <!-- ToDo Add History feature in widget search -->
  <div class="widget-search__list" *ngIf="!listItems && listItemsHistory && listItemsHistory.length > 0">
    <ul>
      <li *ngFor="let item of listItemsHistory; let i = index;" class="widget-search__list-item" [ngClass]="selectedIndex == i ? 'selected' : ''" (click)="selectItem(item, i)">
        <svg style="width: 18px;" class="icon icon--xs" [ngClass]="item.Type == 'CityPage' ? 'icon--dawn' : 'icon--crocus'" viewBox="0 0 32 32" focusable="false">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/Static/img/icons/sprites.svg#icon-map-marker"></use>
        </svg>
        <span>{{ item.Name | titlecase }}</span>
        <span class="search-item-remove" (click)="removeSearchEntry(i)">
          <svg class="icon icon--xs icon--xdark-gray icon--xdark-gray-stroke" stroke-width="5" viewBox="0 0 32 32">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/Static/img/icons/clear-input.svg#web-close"></use>
          </svg>
        </span>
      </li>
    </ul>
  </div>
</div>